// A hub page that moved into Flow: forward there, keeping the query string
// (e.g. ?order=<id> from an alert email). CEO 2026-10-12: every sale lives in Flow.
import { useEffect } from "react";

const FLOW = "https://flow.withother.com";

export function MovedToFlow({ path }: { path: string }) {
  const target = `${FLOW}${path}${window.location.search}`;
  useEffect(() => {
    window.location.replace(target);
  }, [target]);
  return (
    <p className="p-8 text-[15px]">
      This page now lives in Flow. <a className="underline" href={target}>Open it in Flow</a>.
    </p>
  );
}
